import request from '../api'


export class AgeGradeCategoryService {

    async getAgeGradeCategoriesList() {
        const response = await request({
            method: 'GET',
            url: `api/age-grade-categories/list`
        });

        return response;
    }

    static get instance() {
        return ageGradeCategoryService
    }
}

const ageGradeCategoryService = new AgeGradeCategoryService();

export default ageGradeCategoryService;
